import { contractsResource } from './resource'

export const contractsService = {
  getContracts: (signal) => () => contractsResource.get('/api/contracts', { signal: signal() })
}
